function onPassengersInit(inst, elem, struct) {    
    var pure = localStorage.getItem(inst.options.storageKey);
    var urlStruct = GetUrlStructure(elem, inst, inst.options);
    if (urlStruct != undefined && urlStruct != null && pure == null) {        
        struct = urlStruct;
    }
    else {        
        var structemp;
        if (pure != undefined) {
            try {
                data = JSON.parse(pure);                
                structemp = data.content;
            } catch (e) { }
        }
        struct = (structemp != undefined ? structemp : struct);
    }

    inst.options.structure = struct;
    if ($.isFunction(inst.options.onAfterSelect)) {
        inst.options.onAfterSelect.apply(elem, [inst, elem, struct]);
    }
}
function onPassengersSelectedChanged(inst, elem, struct, mode) {
    var queryString = '';
    var title = '';

    if (mode) {
        storagehandler('save', inst.options.storageKey, struct);
    }

    switch (inst.options.structurePreset) {
        case "travelduration":
            var value = struct[0].items.filter(x => x.checked)[0].value;
            inst.elem.val(value);
            var titleformat = "{travelduration}";
            title = titleformat.replace(/{travelduration}/g, struct[0].items.filter(x => x.checked)[0].title);
            break;
        case "flight":
            var queryformat = "&Adult={adult}&Child={child}&Infant={infant}&FlightClass={flightclass}";
            queryString = queryformat
                .replace(/{adult}/g, struct[0].items[0].value)
                .replace(/{child}/g, struct[0].items[1].value)
                .replace(/{infant}/g, struct[0].items[2].value)
                .replace(/{flightclass}/g, struct[1].items.filter(x => x.checked)[0].value);

            var titleformat = "<b>{passengers}</b> مسافر";
            title = titleformat.replace(/{passengers}/g,
                (parseInt(struct[0].items[0].value) +
                    parseInt(struct[0].items[1].value) +
                    parseInt(struct[0].items[2].value))
            ).replace(/{flightclass}/g, struct[1].items.filter(x => x.checked)[0].title);

            break;
        case "hotel":
        case "package":
            var queryformat = "&Rooms={subitems}";
            var subformat = "{adultCount},{child1},{child2},{child3},{child4},{child5}";
            var subitems = [];
            var passengersCount = 0;
            $.each(struct[0].items,
                function (i, v) {

                    var subitem = subformat
                        .replace(/{adultCount}/g, v.items[0].value)
                        .replace(/{child1}/g, (v.items[1].items[0] && v.items[1].items[0].mode != 'reserved') ? parseInt(v.items[1].items[0].value) : 0)
                        .replace(/{child2}/g, (v.items[1].items[1] && v.items[1].items[1].mode != 'reserved') ? parseInt(v.items[1].items[1].value) : 0)
                        .replace(/{child3}/g, (v.items[1].items[2] && v.items[1].items[2].mode != 'reserved') ? parseInt(v.items[1].items[2].value) : 0)
                        .replace(/{child4}/g, (v.items[1].items[3] && v.items[1].items[3].mode != 'reserved') ? parseInt(v.items[1].items[3].value) : 0)
                        .replace(/{child5}/g, (v.items[1].items[4] && v.items[1].items[4].mode != 'reserved') ? parseInt(v.items[1].items[4].value) : 0);

                    subitems.push(subitem);
                    passengersCount += parseInt(v.items[0].value) + parseInt(v.items[1].items.filter(x => x.mode != 'reserved').length);
                });

            queryString = queryformat.replace(/{subitems}/g, subitems.join('|'));

            var titleformat = "<b>{passengers}</b><span class='passengers-style'>مسافر،</span><span class='room-count-style'> <b> {rooms}</b> اتاق</span>";
            title = titleformat
                .replace(/{passengers}/g, (passengersCount))
                .replace(/{rooms}/g, (struct[0].items.length));

            break;
        case "flighthotel":
            var queryformat = "&Rooms={subitems}&FlightClass={flightclass}";
            var subformat = "{adultCount},{child1},{child2},{child3},{child4},{child5}";
            var subitems = [];
            var passengersCount = 0;
            $.each(struct[0].items,
                function (i, v) {
                    var subitem = subformat
                        .replace(/{adultCount}/g, v.items[0].value)
                        .replace(/{child1}/g, (v.items[1].items[0] && v.items[1].items[0].mode != 'reserved') ? v.items[1].items[0].value : 0)
                        .replace(/{child2}/g, (v.items[1].items[1] && v.items[1].items[1].mode != 'reserved') ? v.items[1].items[1].value : 0)
                        .replace(/{child3}/g, (v.items[1].items[2] && v.items[1].items[2].mode != 'reserved') ? v.items[1].items[2].value : 0)
                        .replace(/{child4}/g, (v.items[1].items[3] && v.items[1].items[3].mode != 'reserved') ? v.items[1].items[3].value : 0)
                        .replace(/{child5}/g, (v.items[1].items[4] && v.items[1].items[4].mode != 'reserved') ? v.items[1].items[4].value : 0);

                    subitems.push(subitem);
                    passengersCount += parseInt(v.items[0].value) + parseInt(v.items[1].items.filter(x => x.mode != 'reserved').length);
                });

            queryString = queryformat
                .replace(/{subitems}/g, subitems.join('|'))
                .replace(/{flightclass}/g, struct[1].items.filter(x => x.checked)[0].value);

            var titleformat = "<b>{passengers}</b> مسافر،<b> {rooms}</b> اتاق";
            title = titleformat
                .replace(/{passengers}/g, (passengersCount))
                .replace(/{rooms}/g, (struct[0].items.length))
                .replace(/{flightclass}/g, struct[1].items.filter(x => x.checked)[0].title);
            break;
        case "tour":
            var queryformat = "&Rooms={subitems}";
            var subformat = "{adultCount},{child1},{child2},{child3},{child4},{child5}";
            var subitems = [];
            var passengersCount = 0;
            $.each(struct[0].items,
                function (i, v) {
                    var subitem = subformat
                        .replace(/{adultCount}/g, v.items[0].value)
                        .replace(/{child1}/g, (v.items[1].items[0] && v.items[1].items[0].mode != 'reserved') ? v.items[1].items[0].value : 0)
                        .replace(/{child2}/g, (v.items[1].items[1] && v.items[1].items[1].mode != 'reserved') ? v.items[1].items[1].value : 0)
                        .replace(/{child3}/g, (v.items[1].items[2] && v.items[1].items[2].mode != 'reserved') ? v.items[1].items[2].value : 0)
                        .replace(/{child4}/g, (v.items[1].items[3] && v.items[1].items[3].mode != 'reserved') ? v.items[1].items[3].value : 0)
                        .replace(/{child5}/g, (v.items[1].items[4] && v.items[1].items[4].mode != 'reserved') ? v.items[1].items[4].value : 0);

                    subitems.push(subitem);
                    passengersCount += parseInt(v.items[0].value) + parseInt(v.items[1].items.filter(x => x.mode != 'reserved').length);
                });

            queryString = queryformat.replace(/{subitems}/g, subitems.join('|'));

            var titleformat = "<b>{passengers}</b> مسافر، <b>{rooms}</b> اتاق";
            title = titleformat
                .replace(/{passengers}/g, (passengersCount))
                .replace(/{rooms}/g, (struct[0].items.length));

            break;
        case "insurance":
            var queryformat = "&BirthDay={subitems}";
            var count = 0;
            var subitems = [];
            var years = [12, 65, 70, 75, 80, 85];
            $.each(struct[0].items,
                function (i, v) {
                    count += parseInt(v.value);
                    for (var c = 0; c < v.value; c++) {
                        var year = years[i];
                        var cyear = i > 0 ? (years[i - 1] + 1) : 0;
                        var gc = $.calendars.instance();
                        var date = gc.today().add(-year, 'y');
                        var birthday = gc.formatDate('yyyy-mm-dd', date);
                        var ageRange = ",{yy1}-{yy2}"
                            .replace(/{yy1}/g, cyear)
                            .replace(/{yy2}/g, year);
                        subitems.push(birthday + ageRange);
                    }
                }
            );
            queryString = queryformat.replace(/{subitems}/g, subitems.join('|'));
            var titleformat = "{passengers} مسافر";
            title = titleformat.replace(/{passengers}/g, (count));
            break;
        case "train":
            var queryformat = "&Adult={adult}&Child={child}&Infant={infant}&PType={passengertype}";
            queryString = queryformat
                .replace(/{adult}/g, struct[0].items[0].value)
                .replace(/{child}/g, struct[0].items[1].value)
                .replace(/{infant}/g, struct[0].items[2].value)
                .replace(/{passengertype}/g, struct[1].items.filter(x => x.checked)[0].value);
            var titleformat = "<b>{passengers}</b> مسافر، {trainclass}";
            title = titleformat.replace(/{passengers}/g,
                (parseInt(struct[0].items[0].value) +
                    parseInt(struct[0].items[1].value) +
                    parseInt(struct[0].items[2].value))
            ).replace(/{trainclass}/g, struct[1].items.filter(x => x.checked)[0].title);

            break;
        case "flightclass":
            var queryformat = "&FlightClass={flightclass}";
            queryString = queryformat
                .replace(/{flightclass}/g, struct[0].items.filter(x => x.checked)[0].value);

            var titleformat = "{flightclass}";
            title = titleformat.replace(/{flightclass}/g, struct[0].items.filter(x => x.checked)[0].title);
            break;
        case "flighttriptype":
            var queryformat = "";
            queryString = queryformat
                .replace(/{flighttrip}/g, struct[0].items.filter(x => x.checked)[0].value);

            var titleformat = "{flighttrip}";
            title = titleformat.replace(/{flighttrip}/g, struct[0].items.filter(x => x.checked)[0].title);
            break;
        case "traintriptype":
            var queryformat = "";
            queryString = queryformat
                .replace(/{traintrip}/g, struct[0].items.filter(x => x.checked)[0].value);

            var titleformat = "{traintrip}";
            title = titleformat.replace(/{traintrip}/g, struct[0].items.filter(x => x.checked)[0].title);
            break;
        case "passengers":
        case "passengers-alone":
            var queryformat = "&Adult={adult}&Child={child}&Infant={infant}";
            queryString = queryformat
                .replace(/{adult}/g, struct[0].items[0].value)
                .replace(/{child}/g, struct[0].items[1].value)
                .replace(/{infant}/g, struct[0].items[2].value);

            var titleformat = "{passengers} مسافر";
            title = titleformat.replace(/{passengers}/g,
                (parseInt(struct[0].items[0].value) +
                    parseInt(struct[0].items[1].value) +
                    parseInt(struct[0].items[2].value))
            );
            break;
        case "trainclass":
            var queryformat = "&PType={trainclass}";
            queryString = queryformat
                .replace(/{trainclass}/g, struct[0].items.filter(x => x.checked)[0].value);

            var titleformat = "{trainclass}";
            title = titleformat.replace(/{trainclass}/g, struct[0].items.filter(x => x.checked)[0].title);
            break;
    }

    var container = $(inst.options.popupContainer);
    container.find(".passengers-title").html(title);
    container.find(".passengers-data").val(queryString);

}
function GetUrlStructure(elem, inst, options) {
    var structure = null;
    var device = inst.options.device;
    var urlData = ParseUrl()
    if (!urlData || urlData == undefined) return null;
    switch (inst.options.structurePreset) {
        case "flightclass":
            structure = [
                {
                    "title": "Radio[1]",
                    "type": "radio",
                    "items": [
                        {
                            "title": (device === "desktop") ? "اکونومی کلاس" : "اکونومی",
                            "name": "FlightClass",
                            "id": "FlightClass_1",
                            "value": "Economy",
                            "checked": true
                        },
                        {
                            "title": (device === "desktop") ? "بیزینس کلاس" : "بیزینس",
                            "name": "FlightClass",
                            "id": "FlightClass_2",
                            "value": "Business"
                        },
                        {
                            "title": (device === "desktop") ? "فرست کلاس" : "فرست",
                            "name": "FlightClass",
                            "id": "FlightClass_3",
                            "value": "First"
                        }
                    ]
                }
            ];
            break;
        case "passengers":
            var adult = 1;
            var child = 0;
            var infant = 0;
            if (urlData.adult && urlData.adult > 0)
                adult = urlData.adult;
            if (urlData.child && urlData.child > 0)
                child = urlData.child;
            if (urlData.infant && urlData.infant > 0)
                infant = urlData.infant;
            structure = [
                {
                    "title": "RangeSet[1]",
                    "name": "rangeSet",
                    "type": "rangeSet",
                    "max": 9,
                    "items": [
                        {
                            "title": "بزرگسال",
                            "desc": "",
                            "name": "rangeSet1",
                            "value": adult,
                            "min": 1,
                            "max": -1
                        },
                        {
                            "title": "کودک",
                            "desc": "۲ تا ۱۲ سال",
                            "name": "rangeSet2",
                            "value": child,
                            "min": 0,
                            "max": -1
                        },
                        {
                            "title": "نوزاد",
                            "desc": "تا ۲ سال",
                            "name": "rangeSet3",
                            "value": infant,
                            "min": 0,
                            "max": -1
                        }
                    ]
                }
            ];
            break;
        case "passengers-alone":
            var adult = 1;
            var child = 0;
            var infant = 0;
            if (urlData.adult && urlData.adult > 0)
                adult = urlData.adult;
            if (urlData.child && urlData.child > 0)
                child = urlData.child;
            if (urlData.infant && urlData.infant > 0)
                infant = urlData.infant;

            structure = [
                {
                    "title": "RangeSet[1]",
                    "name": "rangeSet",
                    "type": "rangeSet",
                    "max": 9,
                    "items": [
                        {
                            "title": "بزرگسال",
                            "desc": "",
                            "name": "rangeSet1",
                            "value": adult,
                            "min": 1,
                            "max": -1
                        },
                        {
                            "title": "کودک",
                            "desc": "۲ تا ۱۲ سال",
                            "name": "rangeSet2",
                            "value": child,
                            "min": 0,
                            "max": -1
                        },
                        {
                            "title": "نوزاد",
                            "desc": "تا ۲ سال",
                            "name": "rangeSet3",
                            "value": infant,
                            "min": 0,
                            "max": -1
                        }
                    ]
                }
            ];
            break;
        case "flighttriptype":
            var tripType = 1;

            if (urlData.trip == undefined || urlData.trip == null || urlData.trip == "") return null;
            if (urlData.trip.split('|').length == 1)
                tripType = 1;
            else if (urlData.trip.split('|').length == 2)
                tripType = 2;
            else if (urlData.trip.split('|').length > 2)
                tripType = 3;

            structure = [
                {
                    "title": "Radio[1]",
                    "type": "radio",
                    "items": [
                        {
                            "title": (device === "desktop") ? "یک طرفه" : "یکطرفه",
                            "name": "TripType",
                            "id": "OneWay_x",
                            "value": "OneWay",
                            "checked": tripType == 1
                        },
                        {
                            "title": "رفت و برگشت",
                            "name": "TripType",
                            "id": "RoundTrip_x",
                            "value": "RoundTrip",
                            "checked": tripType == 2
                        },
                        {
                            "title": (device === "desktop") ? "چند مسیری" : "چندمسیری",
                            "name": "TripType",
                            "id": "MultipleDestination_x",
                            "value": "MultipleDestination",
                            "checked": tripType == 3
                        }
                    ]
                }
            ];
            break;
        case "traintriptype":
            var tripType = 1;

            if (urlData.trip == undefined || urlData.trip == null || urlData.trip == "") return null;
            if (urlData.trip.split('|').length == 1)
                tripType = 1;
            else if (urlData.trip.split('|').length == 2)
                tripType = 2;
            else if (urlData.trip.split('|').length > 2)
                tripType = 3;

            structure = [
                {
                    "title": "Radio[1]",
                    "type": "radio",
                    "items": [

                        {
                            "title": (device === "desktop") ? "یک طرفه" : "یکطرفه",
                            "name": "TripType",
                            "id": "OneWay_x",
                            "value": "OneWay",
                            "checked": tripType == 1
                        },
                        {
                            "title": "رفت و برگشت",
                            "name": "TripType",
                            "id": "RoundTrip_x",
                            "value": "RoundTrip",
                            "checked": tripType == 2

                        }
                    ]
                }
            ];
            break;
        case "hotel":
            structure = getHotelModel();
            break;
        default:
            structure = null;
            break;
    }
    return structure;

}
function ParseUrl() {
    var fullUrl = window.location.href;
    var removeableUrl = window.location.origin + window.location.pathname;
    var params = fullUrl.replace(removeableUrl, "").replace('?', '').split('&');
    var result = {};
    for (var paramIndex in params) {
        var param = params[paramIndex].split('=');
        result[param[0].toLowerCase()] = param[1];
    }
    return result;
}
function getHotelModel() {
    var urlData = ParseUrl()
    if (!urlData || urlData == undefined) return null;

    var roomString = urlData.rooms;
    if (roomString == null || roomString == undefined) return null;
    var rooms = roomString.split('|');
    var structDetail = [];
    for (room in rooms) {
        var roomDetail = rooms[room].split(',');
        var adult = roomDetail[0];
        var childs = [];
        if (roomDetail[1] > 0) {
            childs.push(roomDetail[1]);
        }
        if (roomDetail[2] > 0)
            childs.push(roomDetail[2]);
        if (roomDetail[3] > 0)
            childs.push(roomDetail[3]);

        var childStruct = {
            "title": "کودک",
            "name": "child{guid}",
            "type": "extended",
            "value": childs.length.toString(),
            "min": 0,
            "max": -1,
            "items": []
        };
        var childDetail = [];
        for (var childIndex in childs) {
            var childItem = {
                "title": "سن کودک {ncounter}",
                "name": "adult{guid}",
                "type": "normal",
                "value": childs[childIndex].toString(),
                "min": 1,
                "max": 12
            };
            childDetail.push(childItem);
        }

        var childItem = {
            "title": "سن کودک {ncounter}",
            "name": "adult{guid}",
            "type": "normal",
            "mode": "reserved",
            "value": "0",
            "min": 1,
            "max": 12
        };
        childDetail.push(childItem);

        childStruct.items = JSON.parse(JSON.stringify(childDetail))
        var detailItem = [];
        detailItem.push({
            "title": "بزرگسال",
            "name": "adult{guid}",
            "type": "normal",
            "value": adult.toString(),
            "min": 1,
            "max": -1
        });
        detailItem.push(childStruct);
        var detail = {
            "title": "اتاق {ncounter}",
            "type": "rangeSet",
            "max": 4,
            "items": JSON.parse(JSON.stringify(detailItem))
        };
        structDetail.push(detail);
    }

    var tempStructure = [
        {
            "title": "RangeSetCollection[1]",
            "name": "rangeSetCollection",
            "type": "rangeSetCollection",
            "max": 16,
            "maxSet": 4,
            "items": JSON.parse(JSON.stringify(structDetail))
        }];
    return tempStructure;
}
